<template>
  <div class="row">
    <div class="span8 detail-main">
      <el-page-header @back="$router.back()" :content="content.job_name" style="margin-bottom: 18px;"></el-page-header>
      <div style="background: #f8f9fa; border-radius: 4px; padding: 16px 20px; margin-bottom: 20px;">
        <div class="info-unit"><span class="tagname">岗位名称</span>{{ content.job_name }}</div>
        <div class="info-unit"><span class="tagname">类 型</span>{{ content.job_lable }}</div>
        <div class="info-unit"><span class="tagname">薪 资</span><span style="color: #e60000; font-weight: bold;">{{ content.job_salary }}</span></div>
        <div class="info-unit"><span class="tagname">招聘人数</span>{{ content.job_num }}</div>
        <div class="info-unit"><span class="tagname">投递方式</span>{{ content.company_mail }}</div>
      </div>
      <h3 style="font-size: 18px; margin-bottom: 12px;">岗位描述</h3>
      <blockquote class="post-body" v-html="content.job_content" style="margin: 0 0 20px;"></blockquote>
      <h3 style="font-size: 18px; margin-bottom: 12px;">公司信息</h3>
      <el-divider></el-divider>
      <p style="margin-bottom: 12px;">
        <router-link :to="`/companycontent/${content.company_id}`" style="color: #0E7490;">{{ content.company_name }}</router-link>
      </p>
      <el-divider></el-divider>
      <div style="margin: 20px 0; text-align: center;">
        <el-button round disabled>👍 66</el-button>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <job-widget />
    </div>
    <div class="span8">
      <comment-widget />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carouselWidget from '@/components/carousel.vue'
import jobWidget from '@/components/job.vue'
import commentWidget from '@/components/comment.vue'
import { getJobContent } from '@/api'

export default {
  name: 'JobContent',
  components: { carouselWidget, jobWidget, commentWidget },
  props: { id: { type: String, default: '' } },
  data() {
    return { content: {} }
  },
  computed: {
    ...mapState({ commentnum: (s) => s.commentnum })
  },
  watch: {
    id: { immediate: true, handler() { this.getcontent() } }
  },
  methods: {
    getcontent() {
      if (!this.id) return
      getJobContent(this.id).then((res) => {
        this.content = res.data || {}
        this.$store.dispatch('setcontentid', this.id)
        this.$store.dispatch('setcontentinfo', { name: this.content.job_name, userid: this.content.user_id })
      })
    }
  }
}
</script>
